import { render, staticRenderFns } from "./SocialRightSidebar.vue?vue&type=template&id=0714fe90&scoped=true&"
import script from "./SocialRightSidebar.vue?vue&type=script&lang=js&"
export * from "./SocialRightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0714fe90",
  null
  
)

export default component.exports